import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../data/mock";

export const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 md:py-28 bg-white"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-14">
          <span className="text-xs tracking-[0.22em] uppercase font-semibold text-teal-600">
            Frequently asked
          </span>
          <h2
            data-testid="faq-headline"
            className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900"
          >
            Got questions? <span className="text-orange-500">We've got answers.</span>
          </h2>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq, idx) => {
            const open = idx === openIdx;
            return (
              <div
                key={idx}
                data-testid={`faq-item-${idx}`}
                className={`rounded-2xl border transition-all duration-300 overflow-hidden ${
                  open
                    ? "border-orange-300 bg-orange-50/50 shadow-sm"
                    : "border-slate-200 bg-white hover:border-teal-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : idx)}
                  data-testid={`faq-toggle-${idx}`}
                  className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left"
                >
                  <span className="font-heading text-base md:text-lg font-semibold text-slate-900">
                    {faq.q}
                  </span>
                  <span
                    className={`h-9 w-9 shrink-0 rounded-full flex items-center justify-center transition-all ${
                      open
                        ? "bg-orange-500 text-white rotate-180"
                        : "bg-slate-100 text-slate-700"
                    }`}
                  >
                    {open ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 md:px-6 pb-5 md:pb-6 text-slate-600 leading-relaxed text-sm md:text-base">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
